<template>
    <v-card tile flat @click="$emit('click')" class="v-card--none-active-bg">
        <slot v-if="this.$slots['image']" name="image" />
        <v-responsive v-else :aspect-ratio="282 / 370" class="grey lighten-5"></v-responsive>

        <div class="pt-18px pt-md-24px">
            <div class="mb-4px mb-md-8px">
                <div class="font-size-18 font-size-md-20 font-weight-extrabold line-height-135 grey--text text--darken-4 text-truncate">
                    <slot name="subject" />
                </div>
            </div>

            <slot />
        </div>
    </v-card>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
